import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import { osName } from 'react-device-detect';
import { connect } from 'react-redux';
import { formatWithOptions } from 'date-fns/fp';
import { th } from 'date-fns/locale';

import { alertActions, resetFormData, setFormData } from '../../actions';
import { commonConstant, CustomCheckbox, Field, StickyBottom } from '../../common';
import { OTPInput } from '../../helpers';
import { customerService, activityService, amwayService, utilsService } from '../../services';
import _ from 'lodash';
import { BusinessNatureType, FIELD_TYPE, LABEL_ABO_DATE_OF_BIRTH_PLACEHOLDER, LABEL_ACCEPT_TNC, LABEL_SUBMIT, RELEASE_DATE } from '../../common/commonConstant.js';
import HomeAlertModal from '../home/homeAlertModal/HomeAlertModal.jsx';
import { IdField } from '../home/components/index.js';


class Forgot extends Component {
  constructor(props) {
    super(props);

    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      window.location.replace(commonConstant.pathHome);
    }
    const customer = JSON.parse(sessionStorage.getItem('customer'));
    const { location } = props;
    const { state } = location;
    // const isCondition = location.state && location.state.from.pathname === '/abo';
    this.state = {
      customer: customer,
      cid: this.props.forgot.formData?.cid ?? null,
      name: this.props.forgot.formData?.name ?? '',
      lastname: this.props.forgot.formData?.lastname ?? '',
      birthday: this.props.forgot.formData?.birthday ?? '',
      phone: this.props.forgot.formData?.phone ?? '',
      loading: false,
      modalContent: '',
      isOpenModal: false,
      accept: this.props.location?.state.accept || false,
      condition: false,
      state: state,
      isOtpVerified: false,
      isPickerOpen: false,
      amwayForgotResponse: null,
      // isCondition: isCondition,
    };
  }

  checkboxRef = createRef();

  async componentDidMount() {
    const { state } = this.props.location;
    this.checkboxRef.current.checked = this.state.accept;
    if (state && state?.isOtpVerified) {
      this.setState({
        ...state,
        loading: true
      }, async () => {
        const responseData = state.amwayForgotResponse;
        if (!responseData) return;

        const { aboNum, AboName, DistNum, Message, Status, BusinessNature, partyId, cid: resCID } = responseData;
        const { birthdayKey } = this.formatDOB(state.birthday);

        const customer = {
          ...this.state.customer,
          name: AboName,
          _id: this.state.customer._id,
          birthday: `${birthdayKey}`,
          amwayNumber: parseInt(DistNum),
          cid: resCID ? resCID.substr(-4) : null,
          partyId: partyId,
          socialType: 'LINE',
          type: BusinessNatureType[BusinessNature]
        };

        customer.name = AboName;
        sessionStorage.setItem('customer', JSON.stringify(customer));

        const resMemberNumber = await customerService.findMemberByPartyId(DistNum, partyId);

        if (resMemberNumber && (resMemberNumber.uid !== this.state.customer.uid)) {

          await utilsService.deleteUserFromRichmenu(resMemberNumber.uid)
            .then(() => {
              activityService.create({
                service: "customers",
                action: "delete",
                userId: resMemberNumber._id,
                uid: resMemberNumber.uid,
                data: resMemberNumber,
              })
            });
        }

        this.props.history.push('/success', {
          ...state,
          detailType: BusinessNature ? BusinessNatureType[BusinessNature] : 'abo'
        });
      });
    }

  }

  formatDOB = (dt) => {
    const date = new Date(dt);
    const convertYearBEtoAD = date.getFullYear();
    const month = date.getMonth() + 1;
    const monthWithZero = month <= 9 ? `0${month.toString()}` : month.toString();
    const day = date.getDate().toString();
    const dayWithZero = day <= 9 ? `0${day}` : day;

    return {
      birthdayKey: convertYearBEtoAD.toString() + monthWithZero + dayWithZero,
      dob: `${convertYearBEtoAD.toString()}-${monthWithZero}-${dayWithZero}`
    };
  }

  handleChange = e => {
    this.setFormDataInStore(e.target.id, e.target.value);
    this.setState({ [e.target.id]: e.target.value })
  };

  handleCheckBox = () => {
    this.props.history.replace({
      state: {
        ...this.props.location.state,
        accept: !this.state.accept
      }
    });
    this.setState({ accept: !this.state.accept })
  }
  handleTextChange = e => {
    const regex = /^(?!.*[\u0E3F\u0E50-\u0E59])[A-Za-z\u0E00-\u0E4E]{1,30}$/;
    if (e.target.value === '' || regex.test(e.target.value)) {
      this.setFormDataInStore(e.target.id, e.target.value);
      this.setState({ [e.target.id]: e.target.value });
    }
  }

  handleMobileChange = e => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === '' || e.target.value.match(regex)) {
      this.setFormDataInStore(e.target.id, e.target.value);
      this.setState({ [e.target.id]: e.target.value });
    }
  }

  handleCheckValidDate = () => this.state?.birthday?.getTime();

  setFormDataInStore = (key, value) => {
    let formData = this.props.forgot.formData;
    if (formData) {
      formData[key] = value;
      this.props.setFormData(formData);
    } else {
      formData = {};
      formData[key] = value;
      this.props.setFormData(formData);
    }
  }

  handleSubmit = async (e) => {
    window.scrollTo(0, 1);
    e.preventDefault();

    this.setState({
      loading: true,
    }, async () => {
      if (!this.handleCheckValidDate()) {
        this.toggleModal('invalidbd');
        this.setState({ loading: false });
        return false;
      }

      const { birthdayKey, dob } = this.formatDOB(this.state.birthday);
      const cidKey = this.state.cid;
      // const forgetKey = cidKey + birthdayKey;
      const phoneInfo = {
        phoneLocalNum: this.state.phone,
        phoneCntryCd: "66",
        phoneAreaCd: ""
      }

      const response = await amwayService.forgot(phoneInfo, cidKey, dob);

      if (response.status === 500 || !response) {
        this.toggleModal('notfound');
        this.setState({ loading: false });
        return false;
      }

      const { message } = response?.data;

      if (message) {
        try {
          const parsedMessage = JSON.parse(message);
          const { Status } = parsedMessage;

          if (['F', 'I', 'E'].includes(Status)) {
            this.setState({ isOpenModal: false, loading: false });
            this.toggleModal('notfound');
            return;
          }

        } catch (err) {
          this.setState({ loading: false });
          this.toggleModal('notfound');
          return;
        }
      }

      this.setState({ amwayForgotResponse: response.data }, () => {
        this.props.resetFormData();
        this.props.history.push(commonConstant.pathVerifyOtp, {
          ...JSON.parse(JSON.stringify(this.state)),
          birthday: this.state.birthday,
          phoneList: {
            phoneCntryCd: "66",
            phoneLocalNum: this.state.phone
          },
          type: "otp",
        })
      });
    });

  };

  handleCloseModal = () => {
    this.setState({
      isOpenModal: false,
    });
  }
  toggleModal = (content) => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      modalContent: content
    });
  }

  handleModalOk = () => {
    const { modalContent } = this.state;
    this.toggleModal();
    switch (modalContent) {
      case 'notfound':
        return window.location = 'tel:027258000';
      default:
        break;
    }
  }

  handleModalContent = () => {
    const { modalContent } = this.state;
    switch (modalContent) {
      case 'notfound':
        return { title: 'ไม่พบข้อมูล', detail: 'โปรดติดต่อ Amway Contact Center\n02-725-8000', btnText: 'โทร' };
      case 'invalidbd':
        return { title: 'ข้อมูลส่วนตัวไม่ถูกต้อง', detail: 'กรุณาระบุข้อมูลส่วนตัวของคุณใหม่อีกครั้ง', btnText: 'ระบุข้อมูลใหม่' };
      default:
        break;
    }
  }

  handlePickerSubmit = (pickerValue) => {
    this.setFormDataInStore('birthday', pickerValue);
    this.setState({
      birthday: pickerValue,
      isPickerOpen: false,
    });
  };

  handlePickerDelete = () => {
    this.setState({
      birthday: '',
      isPickerOpen: false,
    });
  };

  onPaste = e => {
    e.preventDefault();
    return false;
  };

  render() {
    const { location } = this.props;
    const { birthday, name, lastname, phone, isOpenModal, cid, modalContent, accept, condition, isPickerOpen } = this.state;
    const isTrue = birthday && phone && ((cid && name && lastname) ||
      ((!cid && /^[^\u0E00-\u0E7F]*$/.test(name)) &&
        (!cid && /^[^\u0E00-\u0E7F]*$/.test(lastname)))
    ) ? true : false;
    const btnActive = isTrue && accept ? true : false;

    const content = this.handleModalContent();
    return (
      <div className="regisPage no-bg _pt-35">
        <LoadingOverlay active={this.state.loading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
        {
          isOpenModal ?
            <HomeAlertModal
              title={content.title}
              description={content.detail}
              btnFn={this.handleModalOk}
              cancelBtnFn={this.toggleModal}
              isOpen={isOpenModal}
              onClose={this.toggleModal}
              cancelBtnText={content.cancelBtnText}
              btnText={content.btnText}
            /> : null
        }
        <div className="_header">กรุณากรอกข้อมูลยืนยัน<br />
          เพื่อตรวจสอบการเป็นนักธุรกิจแอมเวย์</div>
        <form onSubmit={this.handleSubmit}>
          <div className="input-personal">

            <div className="away-form">
              <div className="form-group">
                <label htmlFor="name">ชื่อ</label>
                <Field
                  preIconPath='/images/common/AccountIcon.svg'
                  preIconDisabledPath='/images/common/AccountIconDisabled.svg'
                  type={FIELD_TYPE.Text.name}
                  id="name"
                  disabled={false}
                  onChange={this.handleTextChange}
                  defaultValue={name}
                  value={name}
                  placeholder="ระบุชื่อ"
                  maxLength="30"
                  onPaste={this.onPaste}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastname">นามสกุล</label>
                <Field
                  preIconPath='/images/common/AccountIcon.svg'
                  preIconDisabledPath='/images/common/AccountIconDisabled.svg'
                  type={FIELD_TYPE.Text.name}
                  id="lastname"
                  disabled={false}
                  onChange={this.handleTextChange}
                  defaultValue={lastname}
                  value={lastname}
                  placeholder="ระบุนามสกุล"
                  maxLength="30"
                  onPaste={this.onPaste}
                  required
                />
              </div>
              <div className="form-group">
                <IdField
                  heading="วันเกิด"
                  placeholder={LABEL_ABO_DATE_OF_BIRTH_PLACEHOLDER}
                  type={FIELD_TYPE.Date}
                  value={birthday && formatWithOptions({ locale: th }, 'd MMMM yyyy')(birthday)}
                  disabled={false}
                  onDateSubmit={this.handlePickerSubmit}
                  onDateDelete={this.handlePickerDelete}
                  isPickerOpen={isPickerOpen}
                  preIconPath='/images/common/CalendarIcon.png'
                  preIconDisabledPath='/images/common/CalendarIconDisabled.png' />
              </div>
              <div className="form-group">
                <label htmlFor="phone">เบอร์โทรศัพท์</label>
                <Field
                  preIconPath='/images/common/PhoneIcon.svg'
                  preIconDisabledPath='/images/common/PhoneIconDisabled.svg'
                  pattern="[0-9]*"
                  required
                  type="tel"
                  id="phone"
                  value={phone}
                  placeholder="ระบุเบอร์โทรศัพท์"
                  maxLength="10"
                  onChange={this.handleMobileChange} />
              </div>
              <div className="form-group _group">
                <label>หมายเลขบัตรประชาชน 4 หลักสุดท้าย</label>
                <OTPInput id="cid" count={4} inputArray={this.state.cid?.split('')} onChange={(value, obj) => this.handleChange({ target: { id: obj.id, value: obj.value } })} />
              </div>
              <div className='foreign-text'>
                *ชาวต่างชาติไม่ต้องระบุ (Not required for foreigners)
              </div>
            </div>
          </div>
          <div className="forgot-text-center">
            ข้อมูลส่วนตัวของท่านจะได้รับการปกป้องอย่างปลอดภัย
          </div>
          <StickyBottom isActive={btnActive} buttonText={LABEL_SUBMIT} buttonProps={{ type: "submit", disabled: !btnActive, style: { marginTop: 20 } }} >
            <div className="home-registration-tnc-wrapper">
              <CustomCheckbox onChange={this.handleCheckBox} accept={accept} ref={this.checkboxRef} />
              <div className="home-registration-tnc-link">
                <Link className="forget-password" to={{
                  pathname: '/condition',
                  state: { from: location, accept }
                }}>{LABEL_ACCEPT_TNC}</Link>
              </div>
            </div>
          </StickyBottom>
        </form>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    showError: (message) => dispatch(alertActions.showError(message)),
    setFormData: payload => dispatch(setFormData(payload)),
    resetFormData: () => dispatch(resetFormData()),
  };
}

function mapStateToProps({ forgot }) {
  return { forgot };
}

export default connect(mapStateToProps, mapDispatchToProps)(Forgot);
